import * as signalR from "@microsoft/signalr";
import { API_BASE_URL } from "../api/axiosClient";

let connection = null;
const listeners = {};

export async function connectChatHub(token) {
  if (connection && connection.state === signalR.HubConnectionState.Connected) return connection;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${API_BASE_URL}/hubs/chat?access_token=${token}`, {
      accessTokenFactory: () => token
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  // generic dispatcher so components can subscribe via `on(event, cb)`
  ["ReceiveMessage", "ReceiveNotification", "UserOnline", "UserOffline", "MessagesRead", "ChatRequestAccepted"].forEach(
    (event) => {
      connection.on(event, (...args) => {
        (listeners[event] || []).forEach((cb) => cb(...args));
      });
    }
  );

  try {
    await connection.start();
  } catch (err) {
    console.error("SignalR connection error:", err);
  }

  return connection;
}

export function disconnectChatHub() {
  if (connection) {
    connection.stop();
    connection = null;
  }
}

export function getConnection() {
  return connection;
}

export function on(event, callback) {
  if (!listeners[event]) listeners[event] = [];
  listeners[event].push(callback);
  return () => {
    listeners[event] = listeners[event].filter((cb) => cb !== callback);
  };
}

export async function joinConversation(conversationId) {
  if (connection?.state === signalR.HubConnectionState.Connected) {
    await connection.invoke("JoinConversation", conversationId);
  }
}

export async function leaveConversation(conversationId) {
  if (connection?.state === signalR.HubConnectionState.Connected) {
    await connection.invoke("LeaveConversation", conversationId);
  }
}

export async function sendMessage(conversationId, messageText) {
  if (connection?.state === signalR.HubConnectionState.Connected) {
    await connection.invoke("SendMessage", { conversationId, messageText });
  }
}

export async function markAsRead(conversationId) {
  if (connection?.state === signalR.HubConnectionState.Connected) {
    await connection.invoke("MarkAsRead", conversationId);
  }
}
